import Alpine from '@alpinejs/csp';
import * as Scroller from './ScrollListener';

window.Alpine = Alpine;
Alpine.start();

// Images
document.querySelectorAll('.lazyload').forEach(image => {
    if (image.type === 'image/webp') {
        image.srcset = image.dataset.src;
        image.removeAttribute('data-src');
    } else {
        image.src = image.dataset.src;
        image.removeAttribute('data-src');
    }

    image.classList.remove('lazyload')
});

// Waypoint Scroll
const observer = new MutationObserver(function(mutationsList, observer) {
    for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
            // state change, manually re-call window events (only once) and lazy load images
            Scroller.run(window);
            return;
        }
    }
});

document.addEventListener("DOMContentLoaded", function() {
    const app = document.getElementById('app');

    // Setup observer to listen for DOM changes
    observer.observe(app, {characterData: true, childList: true, subtree: true});
    Scroller.run(window);

    document.querySelectorAll('[data-dropdown-trigger]').forEach(function(trigger) {
        trigger.addEventListener('click', function() {
            const targetId = this.getAttribute('data-dropdown-trigger');
            const target = document.querySelector(`[data-dropdown-target="${targetId}"]`);
            trigger.classList.toggle('active');
            if (target) {
                target.classList.toggle('active');
            }
        });
    });
});

window.onresize = () => {
    // Refresh any waypoints
    Scroller.run(window, true);
};
